var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "li",
    {
      staticClass:
        "no-padding no-margin w-100 h-100 d-flex align-items-center justify-content-center gap-10",
    },
    [
      !_vm.isApi2Convert
        ? _c(
            "div",
            {
              staticClass: "free-credit-info",
              attrs: {
                "data-toggle": "tooltip",
                "data-placement": "right",
                title: "Credits",
              },
            },
            [_c("CoinSVGBlue"), _vm._v(" " + _vm._s(this.availableCredit))],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.isApi2Convert
        ? _c(
            "div",
            {
              staticClass:
                "h-100 align-items-center p-header d-none d-md-inline-flex",
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "h-100 align-items-center p-header-2 d-none d-md-inline-flex",
                },
                [
                  _vm.useModalFlow === true
                    ? [
                        _c(
                          "span",
                          {
                            staticClass:
                              "btn font-weight-bold btn-login-outline btn-lg w-auto py-2",
                            attrs: { "data-user-button-login": "" },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                $event.preventDefault()
                                return _vm.clickLoginButton.apply(
                                  null,
                                  arguments
                                )
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "fa fa-sign-in" }),
                            _vm._v(
                              " " +
                                _vm._s(_vm.textLoginButton) +
                                "\n            "
                            ),
                          ]
                        ),
                      ]
                    : [
                        _c(
                          "a",
                          {
                            staticClass: "pr-4 font-weight-bold text-dark",
                            attrs: {
                              id: "login-btn",
                              "data-user-button-login": "",
                              href: _vm.linkLoginButton,
                            },
                          },
                          [
                            _c("i", { staticClass: "fa fa-sign-in" }),
                            _vm._v(
                              " " + _vm._s(_vm.textLoginButton) + "\n          "
                            ),
                          ]
                        ),
                      ],
                ],
                2
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isApi2Convert
        ? _c(
            "div",
            {
              staticClass:
                "h-100 align-items-center p-header d-none d-md-inline-flex",
            },
            [
              _vm.useModalFlow === true
                ? [
                    _c(
                      "span",
                      {
                        staticClass:
                          "pr-4 font-weight-bold text-dark cursor-pointer",
                        attrs: { "data-user-button-login": "" },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            $event.preventDefault()
                            return _vm.clickLoginButton.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "fa fa-sign-in" }),
                        _vm._v(
                          " " + _vm._s(_vm.textLoginButton) + "\n            "
                        ),
                      ]
                    ),
                  ]
                : [
                    _c(
                      "a",
                      {
                        staticClass: "pr-4 font-weight-bold text-dark",
                        attrs: {
                          id: "login-btn",
                          "data-user-button-login": "",
                          href: _vm.linkLoginButton,
                        },
                      },
                      [
                        _c("i", { staticClass: "fa fa-sign-in" }),
                        _vm._v(" " + _vm._s(_vm.textLoginButton) + "\n      "),
                      ]
                    ),
                  ],
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "h-100 align-items-center p-header-2 d-none d-md-inline-flex",
        },
        [
          _vm.useModalFlow === true
            ? [
                _c(
                  "span",
                  {
                    staticClass:
                      "btn font-weight-bold btn-signup btn-lg w-auto py-2",
                    attrs: { "data-user-button-register": "" },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        $event.preventDefault()
                        return _vm.clickSignupButton.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.textSignupButton) +
                        "\n            "
                    ),
                  ]
                ),
              ]
            : [
                _c(
                  "a",
                  {
                    staticClass:
                      "btn font-weight-bold btn-signup btn-lg w-auto py-2",
                    attrs: {
                      "data-user-button-register": "",
                      id: _vm.idSignupButton,
                      href: _vm.linkSignupButton,
                    },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.textSignupButton) +
                        "\n            "
                    ),
                  ]
                ),
              ],
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass:
            "dropdown-toggle w-100 no-sm-border no-sm-border border-right nav-link bg-white d-xs-flex align-items-center h-100 d-flex d-sm-flex d-md-none d-lg-none pr-2 pr-sm-0",
          attrs: {
            role: "button",
            "data-toggle": "dropdown",
            "aria-haspopup": "true",
            "aria-expanded": "false",
            href: "#",
          },
        },
        [
          _c("i", { staticClass: "fa fa-bars pr-2 fg-normal" }),
          _vm._v(" "),
          _c("span", { staticClass: "hidden-mobile text-normal" }, [
            _vm._v(_vm._s(_vm._f("trans")("Menu"))),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "pt-3 pb-3 pr-3 pl-3 dropdown-menu main-user-dropdown dropdown-menu-right dropdown-menu-hover w-100 border bg-white",
          staticStyle: { "margin-top": "-2px" },
        },
        [
          _c(
            "div",
            { staticClass: "h-100 align-items-center" },
            [
              _vm.useModalFlow === true
                ? [
                    _c(
                      "span",
                      {
                        staticClass:
                          "pr-4 font-weight-bold text-dark btn btn-block btn-light",
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            $event.preventDefault()
                            return _vm.clickLoginButton.apply(null, arguments)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.textLoginButton))]
                    ),
                  ]
                : [
                    _c(
                      "a",
                      {
                        staticClass:
                          "pr-4 font-weight-bold text-dark btn btn-block btn-light",
                        attrs: { href: _vm.linkLoginButton },
                      },
                      [_vm._v(_vm._s(_vm.textLoginButton))]
                    ),
                  ],
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "h-100 align-items-center" },
            [
              _vm.useModalFlow === true
                ? [
                    _c(
                      "span",
                      {
                        staticClass:
                          "btn font-weight-bold bg-success text-white btn-block",
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            $event.preventDefault()
                            return _vm.clickSignupButton.apply(null, arguments)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.textSignupButton))]
                    ),
                  ]
                : [
                    _c(
                      "a",
                      {
                        staticClass:
                          "btn font-weight-bold bg-success text-white btn-block fg-white",
                        attrs: {
                          id: _vm.idSignupButton,
                          href: _vm.linkSignupButton,
                        },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.textSignupButton) +
                            "\n                "
                        ),
                      ]
                    ),
                  ],
            ],
            2
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }